import { render, staticRenderFns } from "./DataUsed.vue?vue&type=template&id=652cd0e6&"
import script from "./DataUsed.vue?vue&type=script&lang=js&"
export * from "./DataUsed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports